import { useState } from 'react'
import {
  Show,
  SimpleShowLayout,
  List,
  Datagrid,
  NumberField,
  DateField,
  useRecordContext,
  useListContext,
  Toolbar,
} from 'react-admin'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  makeStyles,
  Box,
} from '@material-ui/core'
import { ChevronRight, ChevronLeft } from '@mui/icons-material'
import illustration1 from '../assets/images/illustration1.svg'

import TextFieldWithTooltip from '../components/text_field_with_tooltip'
import { MecArrayField } from '../mec'

const MEC_PROCESS_ID = 13

const MecDialog = ({ show, handleClose, copro }) => {
  const [ticketMecId, setTicketMecId] = useState(null)
  const handleRowClick = (ticketMecId) => setTicketMecId(ticketMecId)

  const useStyles = makeStyles({
    main_list: {
      '& > .RaList-main .MuiPaper-elevation': {
        boxShadow: 'none !important',
      },
    },
  })
  const classes = useStyles()
  const MECDialogContent = () => {
    const record = useRecordContext()

    if (!record)
      return (
        <Typography>Vous retrouverez ici les mises en concurrence.</Typography>
      )

    return (
      <Grid container>
        <Grid item xs={2}>
          <NumberField source="id" label="N° Ticket" sortable={false} />
        </Grid>
        <Grid item xs={8}>
          <TextFieldWithTooltip
            source="libelle"
            label="Libellé"
            maxLength={50}
          />
        </Grid>
        <Grid item xs={2}>
          <DateField source="created" label="Créé le" />
        </Grid>
      </Grid>
    )
  }

  const Pagination = () => {
    const { page, hasPreviousPage, hasNextPage, setPage } = useListContext()
    if (!hasPreviousPage && !hasNextPage) return null
    return (
      <Toolbar style={{ minHeight: 'auto', padding: '8px' }}>
        {hasPreviousPage && (
          <Button
            key="previous"
            onClick={() => setPage(page - 1)}
            startIcon={<ChevronLeft />}
          >
            Précédent
          </Button>
        )}
        {hasNextPage && (
          <Button
            key="next"
            onClick={() => setPage(page + 1)}
            startIcon={<ChevronRight />}
          >
            Suivant
          </Button>
        )}
      </Toolbar>
    )
  }

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="md" fullWidth>
      {!ticketMecId && (
        <>
          <DialogTitle>Mises en concurrence</DialogTitle>
          <DialogContent>
            <List
              resource="ext_mec_tickets"
              filterDefaultValues={{
                process_id: MEC_PROCESS_ID,
                copro_id: copro.copros_monday_internal_id,
              }}
              basePath="/ext_mec_tickets"
              title=""
              actions={null}
              exporter={false}
              perPage={5}
              pagination={<Pagination />}
              className={classes.main_list}
            >
              <Grid container style={{ alignItems: 'center' }}>
                <Grid item xs={12} md={6}>
                  <Datagrid bulkActionButtons={false} rowClick={handleRowClick}>
                    <MECDialogContent />
                  </Datagrid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box component={'img'} src={illustration1} width={'100%'} />
                </Grid>
              </Grid>
            </List>
          </DialogContent>
        </>
      )}
      {ticketMecId && (
        <Show
          basePath="/"
          resource="ext_mec"
          id={ticketMecId}
          actions={false}
          title=" "
          component="div"
        >
          <SimpleShowLayout>
            <MecArrayField
              onBackClick={() => {
                setTicketMecId(null)
              }}
            />
          </SimpleShowLayout>
        </Show>
      )}
      <DialogActions style={{ padding: '8px 24px' }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
          disableElevation
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MecDialog
